<template>
  <div>
    <Loading :center="false" v-show="loading" />
    <div v-show="!loading">
      <br>
      <Molded> 
        <b-row>
          <b-col xs="12" sm="12" md="12" lg="12" xl="12">
            <RadioGroup title="Mostrar Retorno no Calendário mesmo que a Saída ainda não tenha sido Realizada?"
              field="showReturnWithoutOutput" :formName="formName" :options="[
                { text: 'Sim', value: true },
                { text: 'Não', value: false },
              ]" v-model="parameterOperational.showReturnWithoutOutput" />
          </b-col>
        </b-row>
      </Molded>
      <br>
    </div>
  </div>
</template>

<script>
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import Molded from "@nixweb/nixloc-ui/src/component/layout/Molded";
import RadioGroup from "@nixweb/nixloc-ui/src/component/forms/RadioGroup.vue";

import ParameterOperational from "@/components/modules/adm/parameter/ParameterOperational.js";

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  components: {
    Loading,
    Molded,
    RadioGroup,
  },
  name: "ParameterOperational",
  data() {
    return {
      formName: "updateParameterOperational",
      parameterOperational: new ParameterOperational(),
      urlUpdate: "/api/v1/adm/parameter-operational/update",
      urlGetById: "/api/v1/adm/parameter-operational/get-by-companyid",
      loading: true,
    };
  },
  created() {
    this.getById();
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event"]),
  },
  methods: {
    ...mapActions("generic", ["putApi", "getApi"]),
    ...mapMutations("generic", ["addLoading", "removeLoading", "addEvent"]),
    ...mapMutations("validation", ["resetValidation", "removeFormDirty"]),
    ...mapMutations("user", ["updateParameterRental"]),
    getById() {
      let params = { url: this.urlGetById, id: this.id };
      this.getApi(params).then((response) => {
        if (response.content != null) {
          this.parameterOperational.update(response.content);
        }
        let self = this;
        setTimeout(function () {
          self.loading = false;
          self.removeLoading(["panel"]);
          self.removeFormDirty();
        }, 100);
      });
    },
    update() {
      let params = { url: this.urlUpdate, obj: this.parameterOperational };
      this.putApi(params).then((response) => {
        this.removeLoading(["saveSaveCancel"]);
      });
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "saveSaveCancel") {
          this.update();
        }
      },
      deep: true,
    },
  },
};
</script>
